module.exports = __webpack_public_path__ + "img/bg-party.c0b94fec.jpg";